import React, { useEffect, useState } from "react";

import { Avatar, Grid, Stack, TextField, Typography } from "@mui/material";

import KRAStyles from "../pages/Styles/KRAScreen.module.scss";

interface Props {
  aadhaarData: any;
}

export default function KRAScreen({ aadhaarData }: Props) {
  const [fetechedDetails, setfetechedDetails] = useState(true);

  //  console.log(aadhaarData);

  return (
    <>
      {fetechedDetails ? (
        <Stack alignItems={"center"} height={"max-content"}>
          <p className={KRAStyles.header}>KRA fetched details</p>
          <p className={KRAStyles.desc}>
            Please review your KRA details and verify to proceed
          </p>
          <div className={KRAStyles.containerData}>
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 1, sm: 2, md: 5 }}
            >
              <Grid item xs={12} md={6}>
                <div className={KRAStyles.labeltext}>Name As per PAN</div>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Name As per PAN"
                  variant="outlined"
                  value={aadhaarData?.name}
                  // value={"hhhhhhhh"}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <div className={KRAStyles.labeltext}>Father Name</div>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Father Name"
                  variant="outlined"
                  value={aadhaarData?.father_name}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <div className={KRAStyles.labeltext}>Date of Birth</div>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Date of Birth"
                  variant="outlined"
                  value={aadhaarData?.dob}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <div className={KRAStyles.labeltext}>Gender</div>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Gender"
                  variant="outlined"
                  value={aadhaarData?.gender}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                justifyContent={"center"}
                margin={"auto"}
              >
                <div className={KRAStyles.labeltext}>Email</div>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Email"
                  variant="outlined"
                  value={aadhaarData?.email?.toLowerCase()}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                justifyContent={"center"}
                margin={"auto"}
              >
                <div className={KRAStyles.labeltext}>Pincode</div>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Pincode"
                  variant="outlined"
                  value={aadhaarData?.pincode}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <div className={KRAStyles.labeltext}>Address</div>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  placeholder="Address"
                  variant="outlined"
                  value={aadhaarData?.address}
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </Stack>
      ) : (
        <Stack>
          <Typography>No Details Fetched</Typography>
        </Stack>
      )}
    </>
  );
}
